import { get, post, postNoAuth } from './axios';
import { ConsumerLocale } from '../types/ConsumerLocale';
import { ConsumerToggle, ConsumerToggleResponse } from '../types/ConsumerToggle';
import { ApiResponse } from '../types/ApiResponse';

const detectLanguage = async (text: string | null, auth0IdToken: string | null, consumerId: string | null): Promise<ApiResponse<string | null>> => {
	if (!text) {
		return {
			data: null,
			hasError: false,
			error: null
		};
	}

	try {
		const res = await post(`/linguistnow/resources/v1/ea/detectLocale?q=${consumerId}`, {
				translationType: 'machine',
				text: text
			},
			auth0IdToken);
		return {
			data: res?.detectedLanguage,
			hasError: false,
			error: null
		};
	} catch (error) {
		return {
			data: null,
			hasError: true,
			error: error
		};
	}
};

const getSupportedLanguages = async (auth0IdToken: string | null, consumerId: string | null): Promise<ApiResponse<ConsumerLocale[]>> => {
	try {
		const response = await get(
			`/linguistnow/resources/v1/ea/consumerLocaleIdsWithDisplayNames?q=${consumerId}`, auth0IdToken
		);
		const languages = response as [ConsumerLocale];
		const sortedLanguages = languages.sort((a: ConsumerLocale, b: ConsumerLocale) => a.name.localeCompare(b.name));
		return {
			data: sortedLanguages,
			hasError: false,
			error: null
		};
	} catch (error) {
		return {
			data: [],
			hasError: true,
			error: error
		};
	}
};

const getConsumerToggleOptions = async (auth0IdToken: string | null): Promise<ApiResponse<ConsumerToggleResponse>> => {
	try {
		const response = await get(
			'/linguistnow/resources/v1/ea/consumerToggleOptions', auth0IdToken
		);

		const consumerToggleResponse = response as ConsumerToggleResponse;

		if (consumerToggleResponse?.consumerToggleOptions) {
			consumerToggleResponse.consumerToggleOptions.sort((a: ConsumerToggle, b: ConsumerToggle) =>
				a.name.localeCompare(b.name)
			);
		}
		return {
			data: consumerToggleResponse,
			hasError: false,
			error: null
		};
	} catch (error) {
		return {
			data: null,
			hasError: true,
			error: error
		};
	}
};

const sendEmailActivation = async (email: string): Promise<ApiResponse<boolean>> => {
	try {
		await postNoAuth(`/linguistnow/resources/v1/ea/sendActivationEmail?email=${encodeURIComponent(email)}`, {});
		return {
			data: true,
			hasError: false,
			error: null
		};
	} catch (error) {
		return {
			data: false,
			hasError: true,
			error: error
		};
	}
};

const translateText = async (
	text: string,
	sourceLocale: string | null | undefined,
	targetLocale: string | null | undefined,
	responseId: number | null = null,
	auth0IdToken: string | null,
	consumerId: string | null,
): Promise<ApiResponse<any>> => {
	const translateRequest = {
		sourceContent: text,
		sourceLocale: sourceLocale,
		targetLocale: targetLocale,
		rnResponseProjectId: responseId,
		contentTypeName: 'browser',
		translationType: 'machine',
		incidentId: 'Chrome Plugin',
		textType: 'text',
		threadTypeId: 15,
		translationIterationId: 1,
		userTypeId: 3
	};

	try {
		const translateResponse = await post(`/linguistnow/resources/v1/ea/translate?q=${consumerId}`, translateRequest, auth0IdToken);
		console.debug('translateResponse', translateResponse);
		return {
			data: translateResponse,
			hasError: false,
			error: null
		};
	} catch (error) {
		return {
			data: null,
			hasError: true,
			error: error
		};
	}
};

export {
	detectLanguage,
	getSupportedLanguages,
	translateText,
	getConsumerToggleOptions,
	sendEmailActivation
};
